import { Suspense, lazy } from "react";
import Loader from "../customs/loader/main";
import Layout from "../components/dashboard/main";

const Main = lazy(() => import("../components/examDeferment/main"));

const ExamDeferment = () => {
  return (
    <Layout pageHeading="Exam Deferment">
      <Suspense fallback={<Loader />}>
        <Main />
      </Suspense>
    </Layout>
  );
};

export default ExamDeferment;
